<template>
  <div
    class="d-inline-flex w-100 custom bg-white bg-white-5 pl-3 pr-2 py-3 rounded-lg overflow-hidden"
  >
    <router-link
      class="d-inline-flex flex-shrink-1 min-w-content w-100"
      :to="{ name: 'profile' }"
    >
      <div
        class="line-height-avatar align-self-center font-weight-bolder text-exitos border border-accent aspect-1 bg-secondary avatar-sm rounded-circle text-center flex-shrink-0"
      >
        <span class="letter-avatar" v-text="firstLetter" />
        <div class="icon-avatar">
          <font-awesome-icon icon="pen" class="text-exitos align-self-center" />
        </div>
      </div>
      <div class="user-content pl-2 w-100 position-relative flex-grow-1">
        <h5
          v-text="user?.name"
          class="h5 lh-1 text-white mb-0 line-clamp line-clamp-1-lines"
        />
        <p
          v-text="user?.email"
          class="text-sm font-weight-lighter custom-email-text mb-0 mt-0 line-clamp line-clamp-1-lines"
        />
      </div>
    </router-link>
    <b-button
      title="Sair"
      variant="outline-white"
      class="px-0 py-0 ml-2 border-0 aspect-1 icon-exit align-self-center transform-none flex-shrink-0 flex-grow-1"
      @click.stop.prevent="handleLogout"
    >
      <font-awesome-icon icon="arrow-right-from-bracket" />
    </b-button>
  </div>
</template>
<script setup>
import { getFirstLetter } from "@/helpers/functions/StringHelpers";
import { computed } from "vue";
import { RouterLink } from "vue-router";
import { useRouter } from "vue-router/dist/composables.js";
import { useActions, useState } from "vuex-composition-helpers";

const $router = useRouter();
const { user } = useState("auth", ["user"]);

const firstLetter = computed(() => getFirstLetter(user.value?.name));

const { ActionSignOut } = useActions("auth", ["ActionSignOut"]);

async function handleLogout() {
  await ActionSignOut();

  $router.push({ name: "login", replace: true });
}
</script>
<style scoped lang="scss">
.line-height-avatar {
  line-height: 36px;
  position: relative;

  .letter-avatar {
    opacity: 1;
    transition: opacity 290ms ease-in;
  }

  .icon-avatar {
    opacity: 0;
    position: absolute;
    z-index: 1;
    right: 0;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: opacity 280ms ease-in;
  }
}

.min-w-content {
  min-width: 0;
}

.max-content-fit {
  max-width: 100%;
}

.custom-email-text {
  color: #cecece;
}

.user-content {
  min-width: 0;
}

.custom {
  box-shadow: 0 0 1.5rem rgba(var(--dark-rgb), 0.25);

  &:hover {
    transition: 210ms;
    background-color: rgba(var(--white-rgb), 0.1) !important;
    box-shadow: 0 0 1.5rem transparent;

    .letter-avatar {
      opacity: 0;
    }

    .icon-avatar {
      opacity: 1;
    }
  }

  .icon-exit {
    width: 32px;
    transform: none !important;
  }
}
</style>
